module.exports = __webpack_public_path__ + "img/login5.4a66e7f8.jpg";